import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { message, Cascader, Divider, Button } from 'antd';
import FormMainSliderAdmin from './../../../components/FormMainSliderAdmin';
import { setConfig } from './../../../actions/setConfig';
import { getConfig, getIsSavingConfig, getIsSavedConfig, getPlaces } from './../../../reducers';
import LoadingPage from './../../../components/LoadingPage';
import { setImagesToMainSliderByCityAdmin, setSavedConfig } from './../../../actions/setImagesToMainSliderByCityAdmin';
import { setPlacesToState } from '../../../actions/dataForState/dataForProfile/setPlacesToState';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { storage } from '../../../config/Fire';

function compareUid( a , b ) {
    if (a.uid < b.uid) {
        return -1
    } else {
        if(a.uid > b.uid) {
            return 1
        } else {
            return 0
        }
    }
}

class SliderAdmin extends Component {
    state = {
        previewVisibleImageSlider: false,
        previewImageSlider: '',
        editMainSlider: false,
        fileListSlider: [],
        countrySelected: null,
        provinceSelected: null,
        citySelected: null
    }

    onSubmitImages = values => {
        this.saveDataImages();
    }

    saveDataImages = () => {
        const { countrySelected, provinceSelected, citySelected, fileListSlider } = this.state
        this.props.setImagesToMainSliderByCityAdmin({
            imagesSlider: (fileListSlider && fileListSlider.length > 0) ? fileListSlider : undefined,
            country: countrySelected,
            province: provinceSelected,
            city: citySelected
        });
    }

    //Images

    getBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
    }

    beforeUpload(file) {
        return new Promise((resolve, reject) => {
        setTimeout(() => {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            if (isJPG || isPNG) {
                if(file.size > (1024*1024*2)) { //size max 2MB
                    message.error('El tamaño máximo de la imagen es de 2MB');
                    reject(file);
                } else {
                    resolve(file);
                }
            } else {
                message.error('Solo puedes cargar archivos .jpeg o .png!');
                reject(file);
            }
        }, 0);
        });
    }

    handleCancelImageSlider = () => this.setState({ previewVisibleImageSlider: false });

    handlePreviewImageSlider = async file => {
        if (!file.url && !file.preview) {
            file.preview = await this.getBase64(file.originFileObj);
        }

        this.setState({
            previewImageSlider: file.url || file.preview,
            previewVisibleImageSlider: true,
        });
    };

    handleChangeImageSlider = ({ fileList }) => this.setState(function(prevState, props) { return { fileListSlider: fileList }});

    renderSavedConfig = () => {
        message.success('¡Los cambios se guardaron exitósamente!');
        var isSavedConfig = false;
        this.props.setSavedConfig(isSavedConfig);
        return;
    }

    loadPlaces = () => {
        this.props.setPlacesToState();
        return <LoadingPage />;
    }

    handleExitEdition = () => {
        this.props.onExitSlider();
    }

    onCitySelected = value => {
        if(value.length === 3) {
            const { places } = this.props;
            if(places[value[0]] && places[value[0]].provinces) {
                places[value[0]].provinces.forEach(province => {
                    if(province.name === value[1]) {
                        province.cities.forEach(city => {
                            if(city.name === value[2]) {
                                if(city.mainSlider) {
                                    var imagesSlider = [];
                                    var promisesGetImagesStorage = [];
                                    city.mainSlider.forEach((element, index) => {
                                        var storageSlider = storage.ref().child(element).getDownloadURL().then(url => {
                                            imagesSlider.push({ uid: index, name: index, status: 'done', url: url });
                                        });
                                        promisesGetImagesStorage.push(storageSlider)
                                    });
                                    return Promise.all(promisesGetImagesStorage)
                                    .then(() => {
                                        imagesSlider.sort(compareUid)
                                        this.setState(function(prevState, props) {
                                            return { fileListSlider: imagesSlider, countrySelected: value[0], provinceSelected: value[1], citySelected: value[2] }
                                        })
                                    })
                                    .catch(() => {
                                        this.setState(function(prevState, props) {
                                            return { fileListSlider: [], countrySelected: value[0], provinceSelected: value[1], citySelected: value[2] }
                                        })
                                    })
                                } else {
                                    this.setState(function(prevState, props) {
                                        return { fileListSlider: [], countrySelected: value[0], provinceSelected: value[1], citySelected: value[2] }
                                    })
                                }
                            }
                        });
                    }
                });
            }
        } else {
            this.setState(function(prevState, props) {
                return { fileListSlider: [], countrySelected: null, provinceSelected: null, citySelected: null }
            })
        }
    }

    renderComponents = () => {
        const { places } = this.props;
        var options = []
        const optionsProvinces = []
        if(places["Argentina"] && places.Argentina.provinces) {
            places.Argentina.provinces.forEach(province => {
                if(province["cities"]) {
                    var cities = []
                    province.cities.forEach(city => {
                        cities.push({ value: city.name, label: city.name })
                    });
                    optionsProvinces.push({ value: province.name, label: province.name, children: cities })
                }
            });
            options.push({ value: "Argentina", label: "Argentina", children: optionsProvinces })
        }
        return (
        <Grid>
            <Row center="xs">
                <Col>
                    <Cascader options={options} onChange={this.onCitySelected} placeholder="Seleccione una ciudad" />
                </Col>
            </Row>
            <Row center="xs">
                <Col xs={12}>
                    {
                        this.state.citySelected ?
                            <FormMainSliderAdmin 
                            onSubmit={this.onSubmitImages} isSaving={this.props.isSavingConfig} beforeUpload={this.beforeUpload}
                            handleCancelImageSlider={this.handleCancelImageSlider} handlePreviewImageSlider={this.handlePreviewImageSlider} handleChangeImageSlider={this.handleChangeImageSlider} 
                            fileListSlider={this.state.fileListSlider} previewImageSlider={this.state.previewImageSlider} previewVisibleImageSlider={this.state.previewVisibleImageSlider}/>
                            :
                            <div>
                                <Divider>Fotos slider principal</Divider>
                                <h1>Seleccione una ciudad</h1>
                            </div>
                    }
                    <Button disabled={this.props.isSavingConfig} onClick={this.handleExitEdition}>
                        Volver
                    </Button>
                </Col>
            </Row>
        </Grid>
                        )
    }

    render() {
        return (
            <div>
                {
                    this.props.places ?
                    <div>
                        {this.renderComponents()}
                        {
                            this.props.isSavedConfig && this.renderSavedConfig()
                        }
                    </div>
                    :
                    this.loadPlaces()
                }
            </div>
        );
    }
}

SliderAdmin.propTypes = {
    onExitSlider: PropTypes.func.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setConfig: value => dispatch(setConfig(value)),
    setImagesToMainSliderByCityAdmin: value => dispatch(setImagesToMainSliderByCityAdmin(value)),
    setPlacesToState: value => dispatch(setPlacesToState(value)),
    setSavedConfig: value => dispatch(setSavedConfig(value)),
});

const mapStateToProps = state => ({
    config: getConfig(state),
    places: getPlaces(state),
    isSavingConfig: getIsSavingConfig(state),
    isSavedConfig: getIsSavedConfig(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(SliderAdmin));